import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyNote } from "@/types";

/**
 * This hook is used to update a company note in the company notes query
 * without refetching the entire query.
 */
export const useSetCompanyNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyNoteToUpdate }: { companyNoteToUpdate: CompanyNote }) => {
    queryClient.setQueryData(
      ["company-notes", currentCompanyId],
      (cachedData: CompanyNote[]) => {
        return cachedData.map((companyNote) => {
          if (companyNote.id === companyNoteToUpdate.id) {
            return companyNoteToUpdate;
          }
          return companyNote;
        });
      },
    );
  };
};
